import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "numerico flex h-10 w-full rounded-lg border border-input bg-card px-3 py-2 text-sm font-semibold",
        "shadow-baixa transition-[border-color,box-shadow] duration-200",
        "placeholder:font-sans placeholder:font-normal placeholder:text-muted-foreground/70",
        "hover:border-primary/35",
        "focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/25",
        "disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
